import { Link } from 'react-router';
import { Icon } from '../atoms/Icon';

const TIERS = [
  {
    name: 'Free', price: '$0', period: 'forever',
    feats: [{ t: '50 tokens / day' }, { t: '1 brand' }, { t: 'All models' }, { t: 'Rollover credits', muted: true }, { t: 'Sub-accounts', muted: true }],
    cta: 'Start free',
  },
  {
    name: 'Creator', price: '$19', period: '/ month',
    feats: [{ t: '3,000 tokens / month' }, { t: '3 brands' }, { t: 'All models' }, { t: 'Rollover credits' }, { t: 'Sub-accounts', muted: true }],
    cta: 'Choose Creator',
  },
  {
    name: 'Pro', price: '$49', period: '/ month', featured: true,
    feats: [{ t: '10,000 tokens / month' }, { t: '10 brands' }, { t: 'All models + API' }, { t: 'Rollover credits' }, { t: 'Sub-accounts (3)' }],
    cta: 'Choose Pro',
  },
  {
    name: 'Agency', price: '$149', period: '/ month',
    feats: [{ t: '40,000 tokens / month' }, { t: 'Unlimited brands' }, { t: 'All models + API' }, { t: 'Rollover credits' }, { t: 'Sub-accounts (15)' }],
    cta: 'Choose Agency',
  },
];

function PricingCard({ p, featured }) {
  return (
    <div className="card" style={{
      padding: 28, display: 'flex', flexDirection: 'column', position: 'relative', height: '100%',
      borderColor: featured ? 'rgba(255,77,141,.35)' : 'var(--border)',
      background: featured
        ? 'linear-gradient(180deg, rgba(255,77,141,.10), rgba(255,126,103,.04) 60%, rgba(255,255,255,.04))'
        : 'var(--surface)',
      boxShadow: featured ? '0 30px 80px -30px rgba(255,77,141,.35), 0 0 0 1px rgba(255,77,141,.18) inset' : 'none',
    }}>
      {featured && (
        <span className="chip" style={{ position: 'absolute', top: -14, left: 28, height: 28, background: 'var(--grad)', borderColor: 'transparent', color: '#fff', fontWeight: 700, boxShadow: '0 8px 24px -10px rgba(255,77,141,.6)' }}>
          Most popular
        </span>
      )}
      <div style={{ fontSize: 14, fontWeight: 600, color: featured ? '#FFC2B5' : 'var(--text-2)', letterSpacing: '-0.01em' }}>{p.name}</div>
      <div className="row" style={{ marginTop: 10, alignItems: 'baseline', gap: 6 }}>
        <span style={{ fontSize: 44, fontWeight: 800, letterSpacing: '-0.04em' }}>{p.price}</span>
        {p.period && <span style={{ color: 'var(--text-3)', fontSize: 14 }}>{p.period}</span>}
      </div>
      <div style={{ height: 1, background: 'rgba(255,255,255,.06)', margin: '22px 0' }}/>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12, flex: 1 }}>
        {p.feats.map((f, i) => (
          <li key={i} className="row gap-3" style={{ alignItems: 'flex-start', color: f.muted ? 'var(--text-4)' : 'var(--text-2)', fontSize: 14 }}>
            {f.muted
              ? <span style={{ width: 16, height: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-4)' }}>—</span>
              : <Icon.check size={14} color={featured ? '#FFC2B5' : '#10B981'}/>}
            <span>{f.t}</span>
          </li>
        ))}
      </ul>
      <Link to="/register" className={`btn ${featured ? 'btn-primary' : 'btn-ghost'}`} style={{ marginTop: 24, justifyContent: 'center' }}>
        {p.cta}
      </Link>
    </div>
  );
}

export default function Pricing() {
  return (
    <section id="pricing">
      <div className="container">
        <div className="eyebrow" style={{ marginBottom: 14 }}>Pricing</div>
        <h2 className="h2" style={{ maxWidth: '18ch' }}>
          Simple, <span className="grad-text">transparent</span> pricing.
        </h2>
        <p className="lede" style={{ marginTop: 18, maxWidth: '60ch' }}>
          Start free. Top up when you need more. No surprises.
        </p>

        <div className="pricing-grid" style={{ marginTop: 56, display: 'grid', gap: 16, gridTemplateColumns: 'repeat(4, minmax(0,1fr))', alignItems: 'stretch' }}>
          {TIERS.map((t, i) => (
            <PricingCard key={t.name} p={t} featured={t.featured}/>
          ))}
        </div>

        <div className="card api-pay-card" style={{
          marginTop: 40, padding: 28,
          display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center', gap: 24,
          background: 'linear-gradient(180deg, rgba(99,102,241,.10), rgba(255,255,255,.03))',
          borderColor: 'rgba(129,140,248,.25)',
        }}>
          <div>
            <div className="eyebrow" style={{ color: '#A5B4FC', marginBottom: 8 }}>Just need the API?</div>
            <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em' }}>Pay per output. No subscription.</div>
            <div className="row gap-6" style={{ marginTop: 14, color: 'var(--text-2)', fontSize: 14, flexWrap: 'wrap' }}>
              <span><span style={{ color: 'var(--text-4)' }}>Images </span><span className="mono">from $0.003</span></span>
              <span><span style={{ color: 'var(--text-4)' }}>Videos </span><span className="mono">from $0.04/sec</span></span>
              <span><span style={{ color: 'var(--text-4)' }}>LLM </span><span className="mono">from $0.0001/1K tokens</span></span>
            </div>
          </div>
          <Link to="/register" className="btn btn-ghost" style={{ borderColor: 'rgba(129,140,248,.45)', color: '#A5B4FC' }}>
            Get API key <Icon.arrow size={14}/>
          </Link>
        </div>
      </div>
    </section>
  );
}
